import { color, font } from '@central/ui';
import type { CSSProperties } from 'react';

/** Styles of the dark staff sign-in page (docs/design/AdminSignIn.dc.html). */

export const inputStyles = {
  input: {
    background: color.signInPage,
    borderColor: color.signInInputBorder,
    color: color.signInText,
    minHeight: 44,
  },
  label: { color: color.signInLabel, fontSize: 13, fontWeight: 400, marginBottom: 6 },
  description: { color: color.signInMuted },
  error: { color: color.signInError },
};

/** A one-time code: large monospace digits. */
export const codeInputStyles = {
  ...inputStyles,
  input: {
    ...inputStyles.input,
    fontFamily: font.mono,
    fontSize: 22,
    letterSpacing: '0.2em',
    textAlign: 'center' as const,
    minHeight: 56,
  },
};

export const amberButton: CSSProperties = {
  background: color.consoleMark,
  color: color.consoleSidebar,
};

export const quietButton: CSSProperties = {
  background: color.signInPanelBorder,
  color: color.signInHeading,
  border: `1px solid ${color.signInInputBorder}`,
};

/** An outlined button on the dark panel: "Continue with {provider}". */
export const outlineButton: CSSProperties = {
  background: 'transparent',
  color: color.signInHeading,
  border: `1px solid ${color.signInInputBorder}`,
};

export const bodyText: CSSProperties = {
  margin: 0,
  fontSize: 14,
  lineHeight: '21px',
  color: color.signInLabel,
};
